import ApiRequestManagerInstance from '../ApiRequestManager';
import { ICreateIdRequest } from '../../types/interfaces/login';

function createIdRequest(token: string) {
  const promise = new Promise<string>(async (resolve) => {
    try {
      const response: ICreateIdRequest = (await ApiRequestManagerInstance.post({
        endpoint: {
          url: 'apiUrl',
          section: 'user',
          subsection: 'createId',
          params: token,
        },
      })) as unknown as ICreateIdRequest;
      resolve(`${response.data?.userId}`);
    } catch (e) {
      console.error(e);
      resolve('');
    }
  });

  return promise;
}

export default createIdRequest;
